import {Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {DatePipe, NgIf} from "@angular/common";
import {FormControl, FormGroup, FormsModule, Validators, ReactiveFormsModule } from "@angular/forms";
import {LoaderComponent} from "../../../../shared/components/loader/loader.component";
import {NextButtonDirective} from "../../../../shared/directives/buttons/next.directive";
import {OutlineButtonDirective} from "../../../../shared/directives/outline/outline-button.directive";
import {Reservation} from "../../../../models/Reservation";
import {ReservationGesService} from "../../../../core/services/reservations/reservation-ges.service";
import {ToastrService} from "ngx-toastr";
import { NextGreenButtonDirective } from '../../../../shared/directives/buttons/next-green.directive';
import { CardShadowComponent } from "../utils/card-shadow/card-shadow.component";
import { NextSquareButtonDirective } from '../../../../shared/directives/buttons/next-square.directive';
import { FormInputDirective } from '../../../../shared/directives/forms/form-input.directive';
import { FormSelectSquareDirective } from '../../../../shared/directives/forms/form-select-square.directive';
import { PaymentCardComponent } from "../payment-card/payment-card.component";
import { AuthStateService } from '../../../../core/services/auth/auth-state.service';

import {buildReservationSms} from "../../../../shared/utils/reservation-sms";
@Component({
  selector: 'app-confirm-card',
  standalone: true,
  imports: [
    DatePipe,
    FormsModule,
    LoaderComponent,
    NextButtonDirective,
    NgIf,
    OutlineButtonDirective,
    NextGreenButtonDirective,
    CardShadowComponent,
    NextSquareButtonDirective,
    ReactiveFormsModule,
    FormInputDirective,
    FormSelectSquareDirective,
    PaymentCardComponent
],
  templateUrl: './confirm-card.component.html',
  styleUrl: './confirm-card.component.css'
})
export class ConfirmCardComponent implements OnInit {
  loadingEmail = false;
  loadingSms = false;
  email: string = "";
  messageSended: boolean = false;
  messageError:boolean = false;
  showExtraInfoForm:boolean = false;
  extraInfoForm: FormGroup;

  @Input() isProfessional: boolean = false;

  @Input() admin: boolean = false;

  @Output() resetWithoutRegistrationClick: EventEmitter<void> = new EventEmitter();
  @Output() professionalOtherReservation: EventEmitter<void> = new EventEmitter();
  @Output() adminEmitter: EventEmitter<void> = new EventEmitter();

  @Input() existingReservation!:Reservation;
  @Input() showResetWithoutRegistration:boolean =  false;
  
  protected readonly environment = environment;
  superAdmin: boolean = false;
  paidTried: boolean = false;

  constructor(private reservationGesService: ReservationGesService, private toastrService: ToastrService, private authService: AuthStateService) {
    this.extraInfoForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      lightweigth_vehicle: new FormControl(''),
      heavy_vehicle_over: new FormControl(''),
      diesel: new FormControl(''),
      farm_type: new FormControl('')
    });
  }

  ngOnInit() {
    if (this.existingReservation) {
      this.email = this.existingReservation.email;
    }
  }

  sendMessage(){
    if(this.existingReservation){
      this.messageSended=false;
      this.loadingSms=true;
      let data = {
        phone:this.existingReservation?.phone,
        message: buildReservationSms(this.existingReservation)
      }
      this.reservationGesService.sendMessage(data,this.existingReservation.id).subscribe({
        next:(response)=>{

          if(response.success){
            this.messageError = false;
            this.messageSended = true;
          }
          this.loadingSms=false;
        },

        error:(err)=>{
          this.messageSended = true;
          //console.log(err.error.message);
          this.messageError = true;
          this.loadingSms=false;
        }
      });
    }
  }

  sendProofToEmail(){
    this.loadingEmail = true;
    this.reservationGesService.sendProofToEmail(this.existingReservation!.id, this.email,  this.existingReservation!.phone,this.getCookie('googtrans')).subscribe({
      next: (result) => {
        if (result.success) {
          this.toastrService.success(result.message);
        }
        this.loadingEmail = false;
      },
      error: (error) => {
        this.toastrService.error(error.error.message);
        this.loadingEmail = false;
      }
    })
  }

  getCookie(name: string) {
    const cookies = document.cookie.split("; ");
    for (let cookie of cookies) {
      let [key, value] = cookie.split("=");
      if (key === name) {
        return decodeURIComponent(value.split('/')[2]);
      }
    }
    return 'es'; // Si la cookie no existe
  }

  descargarArchivo() {
    const link = document.createElement('a');
    link.href = `${environment.API_URL}/reservations/proof/${this.existingReservation.id}/${this.existingReservation!.phone}/${this.getCookie('googtrans')}`;
    link.target = '_blank'; // Abre en una nueva pestaña
    link.rel = 'noopener noreferrer'; // Seguridad adicional
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  reset(){
    this.adminEmitter.emit();
  }

}
